import { AttachmentDownloadContext, attachmentsApi } from "@facade/services";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { AttachmentDownloadVariant } from "@facade/contracts";

export const attachmentDownloadUrlQueryKeys = {
  all: ["attachment-download-url"] as const,

  detail: (
    attachmentId: string | null | undefined,
    variant: AttachmentDownloadVariant = "original",
    context?: AttachmentDownloadContext,
  ) =>
    [
      ...attachmentDownloadUrlQueryKeys.all,
      attachmentId,
      variant,
      context?.organizationId ?? null,
      context?.projectId ?? null,
    ] as const,
};

export const attachmentDownloadUrlQueries = {
  detail: (
    attachmentId: string | null | undefined,
    variant: AttachmentDownloadVariant = "original",
    context?: AttachmentDownloadContext,
  ) =>
    queryOptions({
      queryKey: attachmentDownloadUrlQueryKeys.detail(
        attachmentId,
        variant,
        context,
      ),
      queryFn: async () => {
        if (!attachmentId) {
          throw new Error("Cannot fetch attachment download URL without id");
        }

        return attachmentsApi.getUrlById(attachmentId, variant, context);
      },
      enabled: Boolean(attachmentId),
      staleTime: 1000 * 60 * 5,
    }),
};

export function useAttachmentDownloadUrlQuery(
  attachmentId: string | null | undefined,
  variant: AttachmentDownloadVariant = "original",
  context?: AttachmentDownloadContext,
) {
  return useQuery(
    attachmentDownloadUrlQueries.detail(attachmentId, variant, context),
  );
}
